export default "__VITE_ASSET__2wlS0_18__"